module.exports = __webpack_public_path__ + "static/media/icon-cupones-autoservicio.01078df0.svg";